module.exports = __webpack_public_path__ + "static/media/screenshot-fast.a420a818.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Home/screenshot-fast.jpg
// module id = 115
// module chunks = 0